import { pickAddVariant } from '@theme/produktfinder-variants'
import { CartUpdateEvent, CartErrorEvent } from '@theme/events'

function variantsOf(card) {
  const blob = card.querySelector('.produktfinder-variants')
  if (!blob) return []
  try { return JSON.parse(blob.textContent) } catch { return [] }
}

function showError(results, message) {
  if (!results) return
  let note = results.querySelector('.produktfinder-error')
  if (!note) {
    note = document.createElement('p')
    note.className = 'produktfinder-error'
    note.setAttribute('role', 'alert')
    results.appendChild(note)
  }
  note.textContent = message
}

async function addToCart(items, sourceBtns, results, onSuccess) {
  const old = results?.querySelector('.produktfinder-error')
  if (old) old.remove()
  sourceBtns.forEach((b) => { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Wird hinzugefügt…' })
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // `_pf` is an underscore-prefixed line-item property: hidden from the
      // customer in cart/checkout, but persisted on the order line — so sales
      // that came through the Produktfinder can be attributed later.
      body: JSON.stringify({ items: items.map((it) => ({ ...it, properties: { _pf: '1' } })) }),
    })
    if (!res.ok) throw new Error('cart_add_failed')
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
    const cart = cartRes.ok ? await cartRes.json() : null
    document.dispatchEvent(new CartUpdateEvent(cart, 'produktfinder', { source: 'produktfinder', itemCount: cart?.item_count }))
    sourceBtns.forEach((b) => { b.textContent = '✓ Hinzugefügt'; b.classList.add('is-added'); b.disabled = true })
    onSuccess?.()
  } catch (err) {
    document.dispatchEvent(new CartErrorEvent('produktfinder', 'Konnte nicht in den Warenkorb legen.'))
    sourceBtns.forEach((b) => { b.disabled = false; b.textContent = b.dataset.label || 'In den Warenkorb' })
    showError(results, 'Konnte nicht in den Warenkorb legen. Bitte versuch es erneut.')
  }
}

function wire(results) {
  const cards = Array.from(results.querySelectorAll('.produktfinder-card'))

  // per-card add button: inject one when a non-100ml variant is addable
  cards.forEach((card) => {
    const variantId = pickAddVariant(variantsOf(card))
    if (variantId == null) return // only-100ml or unavailable → leave the resource-card's PDP link
    card.dataset.addVariant = String(variantId)
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'produktfinder-card__add'
    btn.textContent = 'In den Warenkorb'
    btn.addEventListener('click', () => addToCart([{ id: variantId, quantity: 1 }], [btn], results))
    card.appendChild(btn)
  })

  // "alle" button
  const allBtn = results.querySelector('[data-produktfinder-add-all]')
  if (allBtn) {
    allBtn.addEventListener('click', () => {
      const includedCards = cards.filter((c) => !c.querySelector('.produktfinder-card__add.is-added'))
      const items = includedCards
        .map((c) => c.dataset.addVariant)
        .filter(Boolean)
        .map((id) => ({ id: parseInt(id, 10), quantity: 1 }))
      if (items.length) addToCart(items, [allBtn], results, () => {
        includedCards.forEach((card) => {
          const btn = card.querySelector('.produktfinder-card__add')
          if (btn) { btn.textContent = '✓ Hinzugefügt'; btn.classList.add('is-added'); btn.disabled = true }
        })
      })
    })
  }
}

window.__produktfinderWireCart = (results) => wire(results)
